<ng-container>
  <header class="dialog__header">
    <h2 class="dialog__title">Edit Text</h2>
  </header>
  <mat-dialog-content fxLayout="column">
    <div formRow>
      <procure-input-rich-text
        [control]="getFormControl('value')"
        [label]="data.label"
        [showFullScreenButton]="false"
      />
    </div>
  </mat-dialog-content>
  <footer class="dialog__footer rich-text-dialog__footer">
    <button
      type="button"
      procure-button
      variant="stroked"
      (click)="onCancel()"
    >
      Cancel
    </button>
    <button
      type="submit"
      procure-button
      color="primary"
      (click)="onSubmit()"
    >
      Apply
    </button>
  </footer>
</ng-container>
